module.exports = __webpack_public_path__ + "static/media/fa-solid-900.49279363.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.svg
// module id = 1246
// module chunks = 0